<template>
  <CRow alignHorizontal="between" alignVertical="center">
    <CCol xl="4" lg="4" md="4" sm="4">
      <img
        class="img-left"
        :src="baseUrl+cardContent.content.image[0].url"
        width="100%"
        alt="Italian Trulli"
      />
      <!-- <img class="img-left" :src="cardContent.imgUrlA" :height="cardContent.imgHeight" alt="Italian Trulli"> -->
    </CCol>
    <CCol xl="4" lg="4" md="4" sm="4">
      <h1 style="font-size:100px;color:black;justify-content:center;display:flex;">VS</h1>
    </CCol>
    <CCol xl="4" lg="4" md="4" sm="4">
      <img
        class="img-left"
        :src="baseUrl+cardContent.content.image[1].url"
        width="100%"
        alt="Italian Trulli"
      />
      <!-- <img class="img-left" :src="cardContent.imgUrlB" :height="cardContent.imgHeight" alt="Italian Trulli"> -->
    </CCol>
  </CRow>
</template>

<script>
export default {
  components: {},
  name: "ComponentVS",
  props: {
    cardContent: Object,
  },
  data() {
    return {
      baseUrl: process.env.VUE_APP_URL_SOUND,
    };
  },

  computed: {},

  watch: {},

  mounted() {},

  created() {},

  beforeDestroy() {},
  methods: {
    checkLangClass() {
      if (this.lang == "CN") {
        return "fontChinese";
      } else if (this.lang == "PIN IN") {
        return "fontPinin";
      } else {
        return "";
      }
    },
  },
};
</script>

<style>
</style>